<template>
  <div :style="{ margin: '2rem' }">
    <v-card>
      <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
        <v-card-title>
          <span class="headline">Atualizar Informações</span>
        </v-card-title>
        <v-card-text>
            <v-container>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
                <v-row v-if="!loading">
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                    v-model="user.name"
                    :rules="requiredRules"
                    label="Nome"
                    maxlength="100"
                    required
                    />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                    label="E-mail"
                    v-model="user.email"
                    :rules="emailRules"
                    maxlength="100"
                    required
                    />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                    v-mask="'(##) #####-####'"
                    label="Telefone Celular"
                    v-model="user.cell"
                    :rules="requiredRules"
                    required
                    />
                </v-col>
                <v-col v-if="user.role !== 1" cols="12" sm="6" md="3">
                    <v-text-field
                    v-mask="maskCpfCnpj()"
                    v-model="user.cpfCnpj"
                    :rules="user.role === 3 ? cnpjRules : cpfRules"
                    :label="user.role === 3 ? 'CNPJ' : 'CPF'"
                    required
                    @keyup="uppercase"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                    type="password"
                    v-model="user.password"
                    label="Trocar Senha"
                    maxlength="100"
                    v-on:keyup.enter="validate"
                    required
                    />
                </v-col>
                </v-row>
            </v-form>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" :disabled="!valid" text @click="validate">Salvar</v-btn>
        </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { isCPF, isCNPJ } from 'brazilian-values'
import DialogLoading from '@/components/loading/DialogLoading'
import message from '@/utils/message'
import api from '@/services/api'
import store from '@/store'
export default {
  components: {
    DialogLoading
  },

  data: () => ({
    loading: true,
    loadingMessage: 'Carregando',
    valid: true,
    requiredRules: [
      v => !!v || 'Informação obrigatória'
    ],
    emailRules: [
      v => !!v || 'Informação obrigatória',
      v => /.+@.+/.test(v) || 'E-mail deve ser válido'
    ],
    cpfRules: [
      v => !!v || 'Informação obrigatória',
      v => isCPF(v) || 'CPF deve ser válido'
    ],
    cnpjRules: [
      v => !!v || 'Informação obrigatória',
      v => isCNPJ(v) || 'CNPJ deve ser válido'
    ],
    realEstateItems: [],
    user: {
      id: null,
      name: null,
      email: null,
      password: null,
      cell: null,
      cpfCnpj: null,
      realState: null,
      role: null
    }
  }),

  created () {
    this.getUser()
  },

  methods: {
    async getUser () {
      try {
        this.loading = true
        const { data } = await api.get(`/users/${store.getters.user.id}`)
        this.user = {
          ...data,
          cpfCnpj: data.cpf_cnpj,
          role: data.role ? data.role.id : null,
          realState: data.realState ? data.realState.id : null
        }
      } catch (error) {
        message.error('Erro ao buscar dados do usuário')
      } finally {
        this.loading = false
      }
    },

    maskCpfCnpj () {
      return this.user.role === 3 ? 'XX.XXX.XXX/XXXX-##' : '###.###.###-##'
    },

    uppercase () {
      this.user.cpfCnpj = this.user.cpfCnpj ? this.user.cpfCnpj.toUpperCase() : null
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    async save () {
      let data = {
        name: this.user.name,
        email: this.user.email,
        password: this.user.password,
        cell: this.user.cell,
        cpf_cnpj: this.user.role !== 1 && this.user.cpfCnpj ? this.user.cpfCnpj.toUpperCase() : null,
        real_state_id: this.user.realState
      }

      this.loading = true
      this.loadingMessage = 'Atualizando'
      try {
        await api.put(`/users/${this.user.id}`, data)
        message.success('Informações atualizadas')
        // this.$router.push({ name: 'clients' })
      } catch (error) {
        message.error('Erro ao atualizar informações')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myInfos/MyInfos.vue